import React from "react";
import {
  ChartBarIcon,
  FunnelIcon,
  UserIcon,
  CalendarIcon,
  ClockIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import Pagination from "../../Pagination";

const ActivityTab = ({
  activityLogs,
  activityPage,
  activityTotalPages,
  loading,
  activityFilters,
  filtersExpanded,
  onFiltersToggle,
  onFilterChange,
  onClearFilters,
  onApplyFilters,
  onPagePrev,
  onPageNext,
  formatDate,
}) => (
  <div className="space-y-6">
    {/* Filters */}
    <div className="block-bg rounded-[10px] p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-white flex items-center space-x-2">
          <FunnelIcon className="w-6 h-6" />
          <span>Сүзгілер</span>
        </h3>
        <svg width="0" height="0" style={{ position: "absolute", pointerEvents: "none" }}>
          <defs>
            <linearGradient id="ag" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4F45E5" />
              <stop offset="100%" stopColor="#7C3AED" />
            </linearGradient>
          </defs>
        </svg>
        <div className="flex items-center space-x-2">
          <button
            onClick={onFiltersToggle}
            className="flex items-center gap-1.5 pl-2 pr-3 py-1.5 text-sm rounded-lg transition-all hover:opacity-80 activity-filter-btn"
          >
            {filtersExpanded
              ? <ChevronUpIcon className="w-4 h-4 flex-shrink-0" style={{ stroke: "url(#ag)" }} />
              : <ChevronDownIcon className="w-4 h-4 flex-shrink-0" style={{ stroke: "url(#ag)" }} />
            }
            <span className="bg-accent-grad bg-clip-text text-transparent">
              {filtersExpanded ? "Жасыру" : "Көрсету"}
            </span>
          </button>
          <button
            onClick={onClearFilters}
            className="px-3 py-1.5 text-sm bg-gray-700 text-gray-300 hover:bg-gray-600 rounded-lg transition-all activity-filter-btn"
          >
            Тазалау
          </button>
        </div>
      </div>

      {filtersExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-4 border-t border-gray-700">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center space-x-1">
              <UserIcon className="w-4 h-4" />
              <span>Пайдаланушы ID</span>
            </label>
            <input
              type="number"
              value={activityFilters.user_id}
              onChange={(e) => onFilterChange("user_id", e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              placeholder="ID енгізіңіз"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Әрекет түрі
            </label>
            <input
              type="text"
              value={activityFilters.action_type}
              onChange={(e) => onFilterChange("action_type", e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              placeholder="Әрекет түрі"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Нысан түрі
            </label>
            <input
              type="text"
              value={activityFilters.entity_type}
              onChange={(e) => onFilterChange("entity_type", e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              placeholder="Нысан түрі"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center space-x-1">
              <CalendarIcon className="w-4 h-4" />
              <span>Басталу күні</span>
            </label>
            <input
              type="datetime-local"
              value={activityFilters.start_date}
              onChange={(e) => onFilterChange("start_date", e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center space-x-1">
              <CalendarIcon className="w-4 h-4" />
              <span>Аяқталу күні</span>
            </label>
            <input
              type="datetime-local"
              value={activityFilters.end_date}
              onChange={(e) => onFilterChange("end_date", e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-600 rounded-lg text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          <div className="flex items-end">
            <button
              onClick={onApplyFilters}
              className="w-full px-4 py-2.5 bg-accent-grad rounded-lg transition-all duration-200 hover:opacity-90"
              style={{ color: "#ffffff" }}
            >
              Сүзгілеу
            </button>
          </div>
        </div>
      )}
    </div>

    {/* Activity Logs */}
    <div className="space-y-4 block-bg rounded-[10px] p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-white flex items-center space-x-2">
          <ChartBarIcon className="w-6 h-6" />
          <span>Белсенділік журналы</span>
        </h3>
        {activityLogs.length > 0 && (
          <span className="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-sm font-medium border border-green-500/30">
            {activityLogs.length} жазба
          </span>
        )}
      </div>

      {loading && activityLogs.length === 0 ? (
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="bg-gray-800/50 border border-gray-700 rounded-xl p-5 animate-pulse"
            >
              <div className="h-4 bg-gray-700 rounded w-3/4 mb-2" />
              <div className="h-3 bg-gray-700 rounded w-1/2" />
            </div>
          ))}
        </div>
      ) : activityLogs.length === 0 ? (
        <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-12 text-center">
          <ChartBarIcon className="w-16 h-16 text-gray-600 mx-auto mb-4" />
          <h4 className="text-lg font-semibold text-gray-400 mb-2">
            Жазбалар табылмады
          </h4>
          <p className="text-sm text-gray-500">
            Сүзгілерді өзгертіп қайта көріңіз
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {activityLogs.map((log) => (
            <div
              key={log.id}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-5 hover:border-gray-600 transition-all"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="w-2 h-2 bg-green-400 rounded-full" />
                    <h4 className="text-white font-semibold truncate">
                      {log.description || log.action_type || "Белгісіз әрекет"}
                    </h4>
                  </div>
                  <div className="space-y-1.5 text-sm text-gray-400 ml-4">
                    <div className="flex items-center space-x-2">
                      <UserIcon className="w-4 h-4" />
                      <span>
                        {log.user_name || "Белгісіз"} (
                        {log.user_email || "N/A"})
                      </span>
                    </div>
                    <div className="flex items-center space-x-4">
                      <span className="flex items-center space-x-1">
                        <span className="text-gray-500">Әрекет:</span>
                        <span className="text-gray-300 font-medium">
                          {log.action_type || "N/A"}
                        </span>
                      </span>
                      <span className="text-gray-600">•</span>
                      <span className="flex items-center space-x-1">
                        <span className="text-gray-500">Нысан:</span>
                        <span className="text-gray-300 font-medium">
                          {log.entity_type || "N/A"}
                        </span>
                      </span>
                      {log.entity_id && (
                        <>
                          <span className="text-gray-600">•</span>
                          <span className="text-gray-500">
                            ID:{" "}
                            <span className="text-gray-300">{log.entity_id}</span>
                          </span>
                        </>
                      )}
                    </div>
                    {log.ip_address && (
                      <div className="text-xs text-gray-500">
                        IP: {log.ip_address}
                      </div>
                    )}
                  </div>
                </div>
                <div className="ml-4 flex-shrink-0 flex items-center space-x-1 text-sm text-gray-400">
                  <ClockIcon className="w-4 h-4" />
                  <span className="whitespace-nowrap">
                    {formatDate(log.created_at)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <Pagination
        page={activityPage}
        totalPages={activityTotalPages}
        loading={loading}
        onPrev={onPagePrev}
        onNext={onPageNext}
      />
    </div>
  </div>
);

export default ActivityTab;
